import React from 'react';
import { Grid, Typography, Box, Container } from '@mui/material';
import { ContainedButton } from '../../../../../commons/hoc';
import Image from 'next/image';
import styles from './PriceValueNewProd.module.scss';
import imgLoader from '../../../../../imgloader';
import { content } from '../../../../../commons/Constants/PriceNewProducts';
import { useRouter } from 'next/router';

export default function PriceValueNewProd({ id, productType }) {
  const Router = useRouter();
  const productContent = content[productType];
  const { title, subtitle, section, img } = productContent;
  return (
    <div className={styles.howItWorksExtender} id={id}>
      <div className={styles.howItWorkSection}>
        <Container maxWidth="xl" className={styles.mainContainer}>
          <Grid container className={styles.gridContainer}>
            {/* LEFT SIDE: Text content */}
            <Grid item xs={12} md={6}>
              <Box className={styles.textContainer}>
                <div className={styles.iconContainer}>
                  <Typography
                    variant="h1"
                    component="h1"
                    color="primary.main"
                    sx={{ textWrap: 'pretty' }}
                  >
                    {subtitle}
                  </Typography>
                </div>
                {/* <Typography
                  variant="h1"
                  color="primary.main"
                  dangerouslySetInnerHTML={{ __html: title }}
                  className={styles.title}
                ></Typography> */}
                <Typography
                  variant="p1-book"
                  color="primary.black"
                  className={styles.section}
                  component="div"
                  dangerouslySetInnerHTML={{ __html: section }}
                  sx={{ textWrap: 'pretty' }}
                ></Typography>

                <ContainedButton
                  onClick={() => {
                    Router.push('#buy', undefined, {
                      shallow: true,
                      scroll: false,
                    });
                  }}
                >
                  Buy Now
                </ContainedButton>
              </Box>
            </Grid>

            {/* RIGHT SIDE: Product image */}
            <Grid item xs={12} md={5}>
              <Box className={styles.imageContainer}>
                <Image
                  src={img}
                  blurDataURL={img}
                  alt="Antioxidants with Vitamin C & Bioflavonoids"
                  loader={imgLoader}
                  layout="fill"
                  objectFit="cover"
                  placeholder="blur"
                  className={styles.productImage}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
}
